import { render, staticRenderFns } from "./HeaderTown.vue?vue&type=template&id=30e5b930&scoped=true&"
import script from "./HeaderTown.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderTown.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HeaderTown.vue?vue&type=style&index=0&id=30e5b930&lang=scss&"
import style1 from "./HeaderTown.vue?vue&type=style&index=1&id=30e5b930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e5b930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e5b930')) {
      api.createRecord('30e5b930', component.options)
    } else {
      api.reload('30e5b930', component.options)
    }
    module.hot.accept("./HeaderTown.vue?vue&type=template&id=30e5b930&scoped=true&", function () {
      api.rerender('30e5b930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderTown.vue"
export default component.exports